import './Ping.css';
import { useState, useEffect } from 'react';


// komponent Ping
export default function Ping(){

    let containerWidth = 700;
    let containerHeight = 200;
    let speedXBall = 3;
    let speedYBall = 2;
    let frameDuration = 10;
    let gameDuration = 500;
    //let points = 0;

    let [ballLeft, setBallLeft] = useState(0);
    let [ballTop, setBallTop] = useState(0);
    //let [speedXBall, setSpeedXBall] = useState(5);
    //let [speedYBall, setSpeedYBall] = useState(5);
    let [ballGoLeft, setBallGoLeft] = useState(false);
    let [ballGoRight, setBallGoRight] = useState(true);
    let [ballGoTop, setBallGoTop] = useState(false);
    let [ballGoDown, setBallGoDown] = useState(true);
    let [points, setPoints] = useState(0);
    let [isStart, setIsStart] = useState(false);
    let [timer, setTimer] = useState(0);


    //Implementing the setInterval method
    useEffect(() => {
        const interval = setInterval(() => {
            if(isStart){
                // ustawiamy timer
                timer++
                setTimer(timer);
                // koniec rozgrywki
                if(timer >= gameDuration){
                    clearInterval(interval);
                    setIsStart(false);
                    // wykorzystanie timera do wyświetlenia informacji końcowej
                    setTimer("GAME OVER! Your points: " + points);
                }
                if (ballGoRight){
                    setBallLeft(ballLeft + speedXBall);
                    if(ballLeft > containerWidth - 10){
                        setBallGoRight(false);
                        setBallGoLeft(true);
                    }
                }
                if (ballGoLeft){
                    setBallLeft(ballLeft - speedXBall);
                    if(ballLeft < 0){
                        setBallGoRight(true);
                        setBallGoLeft(false);
                    }
                }
                if (ballGoTop){
                    setBallTop(ballTop - speedYBall);
                    if(ballTop < 0){
                        setBallGoTop(false);
                        setBallGoDown(true);
                    }
                }
                if (ballGoDown){
                    setBallTop(ballTop + speedYBall);
                    if(ballTop > containerHeight - 50){
                        setBallGoTop(true);
                        setBallGoDown(false);
                    }
                }
            }
        }, frameDuration);
    
        //Clearing the interval
        return () => clearInterval(interval);
    }, [ballLeft, ballTop, speedXBall, speedYBall, ballGoRight, ballGoLeft, ballGoTop, ballGoDown, containerHeight, containerWidth, frameDuration, isStart, timer, points]);

    function addPoint() {
        if(isStart){
            points++;
            setPoints(points);
            alert('point!');
        }
    }
     function startGame(){
        alert("klikaj w kółko");
        // nie resetujemy zegara ani punktów podczas gry
        if(!isStart){
            setTimer(0);
            setPoints(0);
        }
        setIsStart(true);  
     }

    return (
        <div id="ballContainer">
            <div id="ball" style={{left:ballLeft, top:ballTop}} onClick={addPoint}></div>
            <div style={{float: 'left', position:'relative', top:'130px'}}>
                <button onClick={startGame}>start</button>
            </div>
            <div style={{float: 'left', position:'relative', top:'130px'}}>
                <span>{timer}</span>
            </div>
            <div style={{clear: 'both'}}></div>    
        </div>
    )
}